import { debounce } from 'lodash';
import { computed, IReactionDisposer, reaction } from 'mobx';
import { observer } from 'mobx-react';
import pathToRegexp from 'path-to-regexp';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { SpeechData } from '../stores';
import styles from './Speeches.styl';
import { SpeechScrollWrapper } from './SpeechScrollWrapper';

type RouteParams = { year: string, link?: string };
export type SpeechesRouteProps = Partial<RouteComponentProps<RouteParams>>;

@(withRouter as ClassDecorator)
@observer
export class Speeches extends React.Component<{ data: SpeechData[] } & SpeechesRouteProps> {
    static defaultProps = {
        data: [],
    };
    private disposer: IReactionDisposer;
    private pushHistory = () => {
        const { match, history } = this.props;
        this.path !== match.url && history.push(this.path);
    };

    private get pathCompile(): pathToRegexp.PathFunction<RouteParams> {
        const { match } = this.props;
        return pathToRegexp.compile(match.path);
    };

    @computed
    private get path() {
        const year = this.props.data[0].year;
        return this.pathCompile(this.visibleSpeech || { year });
    }

    @computed
    private get visibleSpeeches() {
        const { data } = this.props;
        return data.filter(speech => speech.isVisible);
    }

    @computed
    private get visibleSpeech() {
        return this.visibleSpeeches[0];
    }

    componentDidMount(): void {
        this.disposer = reaction(
            () => this.visibleSpeech,
            debounce(this.pushHistory, 100),
        );
    }

    componentWillUnmount(): void {
        this.disposer();
    }

    render() {
        const { data, match } = this.props;
        const { params } = match;

        if (!data || !data.length) return null; // never

        return (
            <div className={styles.speeches}>
                {data.map(speech => {
                    return (
                        <React.Fragment key={speech.link}>
                            <SpeechScrollWrapper
                                isCurrent={speech.link === params.link}
                                data={speech}
                                path={this.pathCompile(speech)}
                            />
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }
}

